import {WixSdk} from '@wix/js-sdk-wrapper';
import {Player} from '@wix/music-player';
import {merge, Observable} from 'rxjs';
import {tap, withLatestFrom} from 'rxjs/operators';
import {debug} from '../../utils/debug';
import {pubSub} from './pubSub';

export function getWindowObservables(player$: Observable<Player>) {
  const initRemote$ = pubSub('remote-player.request.init-remote').pipe(
    debug('fgw', 'remote-player.request.init-remote'),
    withLatestFrom(player$),
    tap(([_, player]) => {
      WixSdk.PubSub.publish('remote-player.state-update.init', {
        currentTime: player.currentTime,
        trackId: player.currentTrack,
        paused: !player.isPlaying,
      });
    }),
  );

  const play$ = pubSub<{trackId: number}>('remote-player.request.play').pipe(
    debug('fgw', 'remote-player.request.play'),
    withLatestFrom(player$),
    tap(([{trackId}, player]) => {
      if (trackId && player.currentTrack !== trackId) {
        player.setCurrentTrack(trackId);
      }
      player.play();
    }),
  );

  const changeTrack$ = pubSub<{trackId: number}>('remote-player.request.change-track').pipe(
    debug('fgw', 'remote-player.request.change-track'),
    withLatestFrom(player$),
    tap(([{trackId}, player]) => {
      player.setCurrentTrack(trackId);
    }),
  );

  const pause$ = pubSub<{trackId: number}>('remote-player.request.pause').pipe(
    debug('fgw', 'remote-player.request.pause'),
    withLatestFrom(player$),
    tap(([{trackId}, player]) => {
      player.pause();
    }),
  );

  const timeUpdate$ = pubSub<{currentTime: number}>('remote-player.request.time-update').pipe(
    debug('fgw', 'remote-player.request.time-update'),
    withLatestFrom(player$),
    tap(([{currentTime}, player]) => {
      player.updateCurrentTime(currentTime);
    }),
  );

  const changeOrigin$ = pubSub<{origin: string}>('get-window.state-update.change-origin').pipe(
    debug('fgw', 'get-window.state-update.change-origin'),
    withLatestFrom(player$),
    tap(([{origin}, player]) => {
      player.setCurrentOrigin(origin);
    }),
  );

  return merge(initRemote$, play$, changeTrack$, pause$, timeUpdate$, changeOrigin$);
}
